import { EditableProduct, ProductSummary } from "features/catalogue/types";
import { scaffoldEdit } from "common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "MENUITEM/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "MENUITEM/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "MENUITEM/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "MENUITEM/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "MENUITEM/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "MENUITEM/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableProduct, ProductSummary, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };
